import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { SweetAlertHelper } from '../../../../core/helpers/sweet-alert-helper.service';

// declare const firebase: any;

@Injectable()
export class DebugLogService {

  constructor(private sweetAlertHelper: SweetAlertHelper) {}

  getAllLog(): any {
    // return new Observable<any>(data => {
    //   firebase.firestore().collection('DebugLog').onSnapshot({
    //     includeMetadataChanges: true
    //   }, (doc: any) => {
    //       const tem = [];
    //       doc.forEach((childSnapshot: any) => {
    //         tem.push({ id: childSnapshot.id, data: childSnapshot.data()});
    //       });
    //       data.next(tem);
    //   });
    // });
  }

  deleteLog(idDocument: string) {
    // firebase.firestore().collection('DebugLog').doc(idDocument)
    // .delete().then((res: any) => {
    //   this.sweetAlertHelper.createCustomAlert({
    //     title: 'Success',
    //     text: 'Document successfully deleted!',
    //     type: 'success',
    //   });
    // }).catch((error: any) => {
    //   this.sweetAlertHelper.createCustomAlert({
    //     title: 'Error',
    //     text: 'Error removing document:' + error,
    //     type: 'error'
    //   });
    // });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/debuger-app/services/debug-log.service.ts